import { createFileRoute, Outlet, useNavigate, useRouterState } from '@tanstack/react-router';
import { Stack, Tabs, Title } from '@mantine/core';

export const Route = createFileRoute('/_app/workforce')({ component: WorkforceLayout });

const TABS = [
  { value: 'dashboard', label: 'Dashboard', path: '/workforce/dashboard' },
  { value: 'today', label: 'Chi c\'è oggi', path: '/workforce/today' },
  { value: 'employees', label: 'Dipendenti', path: '/workforce' },
  { value: 'sites', label: 'Sedi', path: '/workforce/sites' },
  { value: 'roles', label: 'Ruoli HR', path: '/workforce/roles' },
  { value: 'areas', label: 'Aree', path: '/workforce/areas' },
  { value: 'groups', label: 'Gruppi', path: '/workforce/groups' },
  { value: 'external', label: 'Esterni', path: '/workforce/external' },
  { value: 'site-presences', label: 'Presenze sede', path: '/workforce/site-presences' },
  { value: 'training', label: 'Formazione', path: '/workforce/training' },
] as const;

function WorkforceLayout() {
  const navigate = useNavigate();
  const path = useRouterState({ select: (s) => s.location.pathname });
  const active = TABS.find((t) => (t.path === '/workforce' ? path === '/workforce' : path.startsWith(t.path)))?.value ?? 'employees';
  return (
    <Stack>
      <Title order={1}>Workforce</Title>
      <Tabs value={active} onChange={(v) => {
        const tab = TABS.find((t) => t.value === v);
        if (tab) void navigate({ to: tab.path });
      }}>
        <Tabs.List>
          {TABS.map((t) => (
            <Tabs.Tab key={t.value} value={t.value}>{t.label}</Tabs.Tab>
          ))}
        </Tabs.List>
      </Tabs>
      <Outlet />
    </Stack>
  );
}
